const RETURN_URL_KEY = 'auth_return_url';
const CALLBACK_PATH = '/empty';

export function getCurrentRelativeUrl(): string {
  const { pathname, search, hash } = window.location;
  return `${pathname}${search}${hash}`;
}

export function isCallbackUrl(url: string): boolean {
  const [path] = url.split(/[?#]/);
  return path === CALLBACK_PATH || path === `${CALLBACK_PATH}/`;
}

export function saveReturnUrl(url: string = getCurrentRelativeUrl()): void {
  if (isCallbackUrl(url) || url === '/' || url === '') return;
  try {
    sessionStorage.setItem(RETURN_URL_KEY, url);
  } catch {
    //
  }
}

export function consumeReturnUrl(): string | null {
  try {
    const url = sessionStorage.getItem(RETURN_URL_KEY);
    sessionStorage.removeItem(RETURN_URL_KEY);
    if (!url || !url.startsWith('/') || url.startsWith('//')) return null;
    return url;
  } catch {
    return null;
  }
}
